(() => {
  const selector = '[data-ela-hero-carousel]';

  function initialise(root) {
    if (!root || root.dataset.elaCarouselReady === 'true') return;

    const slides = Array.from(root.querySelectorAll('[data-ela-hero-slide]'));
    const dots = Array.from(root.querySelectorAll('[data-ela-hero-dot]'));
    const status = root.querySelector('[data-ela-hero-status]');
    if (slides.length < 2) return;

    root.dataset.elaCarouselReady = 'true';
    let activeIndex = Math.max(0, slides.findIndex((slide) => slide.classList.contains('is-active')));
    let pointerStartX = null;

    const activate = (nextIndex, announce = true) => {
      activeIndex = (nextIndex + slides.length) % slides.length;

      slides.forEach((slide, index) => {
        const active = index === activeIndex;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', String(!active));
        slide.inert = !active;
      });

      dots.forEach((dot, index) => {
        const active = index === activeIndex;
        dot.classList.toggle('is-active', active);
        if (active) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });

      if (announce && status) status.textContent = slides[activeIndex].dataset.statusLabel || '';
    };

    root.querySelector('[data-ela-hero-prev]')?.addEventListener('click', () => activate(activeIndex - 1));
    root.querySelector('[data-ela-hero-next]')?.addEventListener('click', () => activate(activeIndex + 1));
    dots.forEach((dot, index) => dot.addEventListener('click', () => activate(index)));

    root.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        activate(activeIndex - 1);
      }
      if (event.key === 'ArrowRight') {
        event.preventDefault();
        activate(activeIndex + 1);
      }
    });

    root.addEventListener('pointerdown', (event) => {
      if (event.pointerType !== 'mouse') pointerStartX = event.clientX;
    }, { passive: true });

    root.addEventListener('pointerup', (event) => {
      if (pointerStartX === null) return;
      const distance = event.clientX - pointerStartX;
      pointerStartX = null;
      if (Math.abs(distance) < 48) return;
      activate(activeIndex + (distance < 0 ? 1 : -1));
    }, { passive: true });

    root.addEventListener('shopify:block:select', (event) => {
      const index = slides.findIndex((slide) => slide.dataset.blockId === event.detail.blockId);
      if (index >= 0) activate(index, false);
    });

    activate(activeIndex, false);
  }

  const initialiseAll = (scope = document) => {
    if (scope.matches?.(selector)) initialise(scope);
    scope.querySelectorAll?.(selector).forEach(initialise);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialiseAll(), { once: true });
  } else {
    initialiseAll();
  }

  document.addEventListener('shopify:section:load', (event) => initialiseAll(event.target));
})();
